import * as Yup from 'yup';

export const validationSchemaAddPatient = new Yup.ObjectSchema({
    full_name:Yup.string().required('Cannot be empty'),
    contact:Yup.string().required('Cannot be empty').matches(/^(?:(?:\+|0{0,2})91|[0])?[6789]\d{9}$/,'Please enter valid phone number'),
    // email:Yup.string().required('Cannot be empty').email('Invalid email'),
});

export const initialValuesAddPatient = {
    full_name: "",
    email: "",
    contact: "",
}

export const feildsAddPatient =() => [
    {
        name:'full_name',
        placeholder:'Enter full name',
        id:'full_name',
        type:'text',
        label:'Patient Name'
    },
    {
        name:'email',
        placeholder:'Enter email here',
        id:'email',
        type:'email',
        label:'Patient Email'
    },
    {
        name:'contact',
        placeholder:'Enter phone number here',
        id:'contact',
        type:'contact',
        label:'Patient Contact'
    },
];

// Keep old exports for backward compatibility
export const validationSchemaAddCustomer = validationSchemaAddPatient;
export const initialValuesAddCustomer = initialValuesAddPatient;
export const feildsAddCustomer = feildsAddPatient;